import { render } from "./PhotoListHomeItemEmpty.vue?vue&type=template&id=397da712&ts=true"
import script from "./PhotoListHomeItemEmpty.vue?vue&type=script&lang=ts"
export * from "./PhotoListHomeItemEmpty.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__